export interface ValidityProps {
  label: string;
  value: number;
}

export class Validity {
  private readonly _label: string;
  private readonly _value: number;

  constructor(props: ValidityProps) {
    this._label = props.label;
    this._value = props.value;
  }

  public get label(): string {
    return this._label;
  }

  public get value(): number {
    return this._value;
  }
}
